module.exports = __webpack_public_path__ + "img/Frame 178.66734c37.png";